module.exports = __webpack_public_path__ + "static/media/contract2.d9aaa648.png";